import { FC } from "react";
import { StorageTemplate } from "../../../redux/slices/grainTracker/grainTrackerTypes";
import { IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

type GrainWiseTonsToWheatParams = {
  t: (arg0: string) => string;
  selectedSpecie: StorageTemplate | undefined;
  totalTons: number;
};

const GrainWiseTonsToWheat: FC<GrainWiseTonsToWheatParams> = ({
  t,
  selectedSpecie,
  totalTons,
}) => {
  return (
    <div className="info-tons-computation">
      {t("Grain_tracker.equivalent-text")}
      <span className="ml-1" />
      {selectedSpecie?.textId.text}: {totalTons.toFixed(2)}{" "}
      {t("Grain_tracker.ton-text")}{" "}
      <Tooltip
        title={t("Grain_tracker.tons-equivalent-explain")}
        placement="right"
      >
        <IconButton>
          <InfoOutlinedIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default GrainWiseTonsToWheat;
